import { Box, Stack, Typography } from '@offline-mui/material'
import type { ReactNode } from 'react'

type PageHeaderProps = {
  eyebrow?: ReactNode
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
  children?: ReactNode
}

/**
 * Standard page heading: eyebrow, title, description on the left and an
 * optional action cluster on the right.
 */
export default function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  children,
}: PageHeaderProps) {
  return (
    <Box className="fcc-fade-up" sx={{ mb: { xs: 2.5, md: 3 } }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        sx={{ alignItems: { md: 'flex-end' }, justifyContent: 'space-between' }}
      >
        <Box sx={{ minWidth: 0 }}>
          {eyebrow ? (
            <Typography
              variant="overline"
              sx={{ color: 'primary.main', display: 'block', mb: 0.5 }}
            >
              {eyebrow}
            </Typography>
          ) : null}
          <Typography variant="h4" component="h1">
            {title}
          </Typography>
          {description ? (
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mt: 0.75, maxWidth: 720 }}
            >
              {description}
            </Typography>
          ) : null}
        </Box>
        {actions ? (
          <Stack
            direction="row"
            spacing={1.25}
            useFlexGap
            sx={{ flexWrap: 'wrap', flexShrink: 0, alignItems: 'center' }}
          >
            {actions}
          </Stack>
        ) : null}
      </Stack>
      {children}
    </Box>
  )
}
